/**
 * Runtime configuration.
 *
 * VITE_API_BASE_URL:
 *   Empty string = static-only mode. The RFQ form falls back to a mailto/copy flow.
 *   Set to e.g. "https://api.your-domain.com" when the FastAPI server is deployed.
 *
 * VITE_CONTACT_EMAIL:
 *   Optional. Used by the mailto fallback when the API is not configured.
 *   Leave empty to use the copy-summary fallback only.
 *
 * VITE_PUBLIC_URL:
 *   Optional canonical public URL, used in docs/OG tags later.
 */
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '')
export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL || ''
export const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL || ''

export const DEMO_ZIP_URL = '/demo/demo-board.zip'
export const DEMO_BOM_URL = '/demo/demo-bom.csv'
export const RATE_CARD_VERSION = 'v0.1'
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024
export const APP_VERSION = '0.1.0'
